function updateDialogMode(data) {
  return {
    type: 'UPDATE_DIALOG_MODE',
    data,
  };
}

export {updateDialogMode};
